import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { BackendLoyaltyService } from '../../services/backend-loyalty.service';
import { CustomerActions } from '../../actions/loyalty/actions-customer';
import { IProfileModel } from '../../models/loyalty/IProfile.model';
import * as CustomerAction from '../../actions/loyalty/actions-customer';

@Injectable()
export class EffectsCustomer {
  getCustomer$: Observable<CustomerActions> = createEffect(() => {
    return this.actions$.pipe(
      ofType<CustomerAction.GetCustomer>(CustomerAction.GET_CUSTOMER),
      switchMap(request =>
        this.backendLoyaltyService.getCustomer(request['payload'].storeCode).pipe(
          map((data: IProfileModel) => new CustomerAction.GetCustomerSuccess(data)),
          catchError(() => of(new CustomerAction.GetCustomerError('pageSectionIsNotAvailable')))
        )
      )
    )
  });

  constructor(
    private readonly actions$: Actions,
    private readonly http: HttpClient,
    private readonly store: Store<any>,
    private readonly backendLoyaltyService: BackendLoyaltyService
  ) { }
}
